import React from 'react'
import { Select, MenuItem, FormControl } from '@mui/material'

import appUtilities from '../utilities/appUtilities.js'

export default function GridBomSelect({
    productRow,
    handleInputChange,
    handleValue,
}) {
    const { productIDNum, itemQty } = productRow
    let range = appUtilities.rangeModifier(itemQty)
    // TODO: 07/05/23 some ideas - if the range is 0 to 10 and he wants 55 he can keystroke 55 and range expands for him
    // TODO: 07/05/23 another is that in planning what range we could have one array of 0-2000 and then use calc to snip whatever necessary of that array.

    return (
        // TODO: 05/06/23 include aria values for the blo controls complete w prop values
        <FormControl>
            <Select
                // aria-labelledby="demo-radio-buttons-group-label"
                id={`select-id-${productIDNum}`}
                name={`select-name-${productIDNum}`}
                // label={'Order Qty'}
                onChange={(e) => handleInputChange(e, { productIDNum })}
                value={handleValue(productIDNum)}
                className="grid-select"
                inputProps={{
                    id: productIDNum,
                }}
                sx={{
                    '& .MuiSelect-select': {
                        pt: 0.2,
                        pb: 0,
                        pl: 0.2,
                        pr: 1,
                        //
                        // mt: 0,
                        // mb: 0,
                        // fontSize: '0.9rem',
                        justifyContent: 'center',
                        minWidth: '2.5rem',
                        // textAlign: 'right',
                    },
                    // minWidth: '100px',
                    paddingTop: '0px',
                    pb: 0,
                    pl: 0,
                    //
                    // mt: 1,
                    // mb: 0,
                    // minWidth: '2.6rem',
                    // justifyContent: 'flex-end',
                    // textAlign: 'right',
                    // boxShadow: `0px 0px 0px 0.5px grey`,
                }}
                // sx={{
            >
                {Array(range)
                    .fill(null)
                    .map((_, index) => {
                        const input = index
                        const display = index
                        return (
                            <MenuItem key={input} value={input}>
                                {display}
                            </MenuItem>
                        )
                    })}
            </Select>
        </FormControl>
    )
}
